import { Spacing } from '@billy/design-system'
import styled from '@emotion/styled'

export const SettingsSectionFooterWrapper = styled.div`
  margin-top: ${Spacing.S32};
`
